import React, { useState, useEffect } from "react";
import { Stack, Heading, Spinner, Image } from "@chakra-ui/core";
const loadingTexts = [
  "Allumage des fourneaux...",
  "Préparation des burgers en cours...",
  "Recherche des sauces en cours...",
  "Nettoyage de la salle en cours...",
  "En train de tester votre patience...",
  "Cuisson des steaks en cours...",
  "La faim justifie les moyens...",
  "Épluchage des pommes de terres...",
  "En train de hacher la viande...",
];

const LoadingPage = () => {
  const [loadingText, setLoadingText] = useState();

  useEffect(() => {
    setLoadingText(loadingTexts[Math.floor(Math.random() * loadingTexts.length)]);
  }, []);

  return (
    <Stack
      spacing="8"
      display="flex"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      bg="gray.50"
      w="full"
      h="100vh"
    >
      <Image h="10" w="auto" src="/images/logo.png" alt="La Citadelle" fallbackSrc="/images/logo.png" />
      <Heading size="lg" textAlign="center">
        {loadingText}
      </Heading>

      <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="brand.500" size="lg" />
    </Stack>
  );
};

export default LoadingPage;
